export const userConstants = {
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  INSTOREMUSIC_LOGIN_REQUEST: 'INSTOREMUSIC_USERS_LOGIN_REQUEST',
  INSTOREMUSIC_LOGIN_SUCCESS: 'INSTOREMUSIC_USERS_LOGIN_SUCCESS',
  INSTOREMUSIC_LOGIN_FAILURE: 'INSTOREMUSIC_USERS_LOGIN_FAILURE',


  LOGOUT: 'USERS_LOGOUT',

  OBTAIN_NETWORK_SUCCESS: 'USERS_OBTAIN_NETWORK_SUCCESS',
  OBTAIN_NETWORK_FAILURE: 'USERS_OBTAIN_NETWORK_FAILURE',

  OBTAIN_TOKEN_REQUEST: 'USERS_OBTAIN_TOKEN_REQUEST',
  OBTAIN_TOKEN_SUCCESS: 'USERS_OBTAIN_TOKEN_SUCCESS',
  OBTAIN_TOKEN_FAILURE: 'USERS_OBTAIN_TOKEN_FAILURE'
}